module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/联系我们banner.31bbe24d.png";